import { theme } from "@chakra-ui/core";

export const customTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    default: {
      500: '#EEEEEE',
      600: '#574C57'
    },
    primary: {
      500: '#93328E',
      600: '#802a7b'
    },
    secondary: {
      500: '#736973',
      600: '#802a7b'
    },
    gray: {
      100: '#EFEEEF'
    },
    active: {
      500: '#93328E'
    }
  },
  sizes: {
    ...theme.sizes,
    md: '2.75rem',
    10: '2.75rem'
  }
}